<template>
    <div v-if="result" class="def-labels">
        <span
            v-for="item in result"
            class="def-labels__item"
            :style="`color: ${ item.color }`"
        >
            {{ item.name }}
        </span>
    </div>
</template>

<script>
export default {
    name: 'DefLabels',
    props: ['result'],
}
</script>

<style lang="scss" scoped>
.def-labels{
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: flex-end;

    &__item{
        font-weight: 600;
        font-size: rem(14);
        line-height: 100%;
        letter-spacing: 0.05em;
        text-transform: uppercase;
        white-space: nowrap;
        margin: 20px 10px 8px 0;
        padding: 5px 5px;
        border: 1px solid;
        &:not(:last-child){
            margin-right: 12px;
        }
    }
}
</style>